module.exports = __webpack_public_path__ + "assets/45b387755765196ef47f9c4c03718c46.mp3";